import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

const STX_APP = window.secutix.__APP__;
const style = STX_APP.style.properties ? STX_APP.style.properties : {};
const config = STX_APP.config || {};
const faviconUrl = style.faviconUrl
  ? style.faviconUrl
  : 'data:image/x-icon;base64,AAABAAEAEBAQAAAAAAAoAQAAFgAAACgAAAAQAAAAIAAAAAEABAAAAAAAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAACAAAAAgIAAgAAAAIAAgACAgAAAwMDAAICAgAAAAP8AAP8AAAD//wD/AAAA/wD/AP//AAD///8A//////////////////////+ZmZmZmZmf/5mZmZmZmZ//mZmZmZmZn/+ZmZmZmZmf/5mZmZmZmZ//mZmZmZmZn/+ZmZmZmZmf/5mZmZmZmZ//mZmZmZmZn/+ZmZmZmZmf//mZmZmZmZ//+ZmZmZmZn////3g5mZmf//////////8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA';

const isUrlHasParamter = url => url.indexOf('?') !== -1;
// Remove language param in URL. ( play.shop.com/content?lang=fr => play.shop.com )
const removeLangParam = url => {
  if (url.indexOf('lang') === -1) {
    return url;
  }
  const langStr = url.substring(url.indexOf('lang') - 1);
  return url.replace(langStr, '');
}

const currentUrl = removeLangParam(window.location.href);
const splitChar = isUrlHasParamter(currentUrl) ? '&' : '?';
const currentUrlWithLang = locale => currentUrl && `${currentUrl}${splitChar}lang=${locale}`;

const AppHelmet = ({ locale }) => {
  return (
    <Helmet link={[{ rel: 'icon', type: 'image/x-icon', href: faviconUrl }]}>
      {config.pageTitle && <title>{config.pageTitle[locale]}</title>}
      {config.pageDescription && (
        <meta name="description" content={config.pageDescription[locale]} />
      )}
      {currentUrlWithLang(locale) && <link rel="canonical" href={currentUrlWithLang(locale)} />}
      <html lang={locale} />
    </Helmet>
  );
};

AppHelmet.propTypes = {
  locale: PropTypes.string,
};

AppHelmet.defaultProps = {
  locale: 'en',
};

export default AppHelmet;
